<template>
    <TooltipComp
        v-if="text"
        :text="text"
        :placement="position"
    >
        <HelpIcon />
    </TooltipComp>
</template>
<script lang="ts" setup>
import { HelpIcon, TooltipComp } from '@/components';

withDefaults(
    defineProps<{
        text?: string;
        position?: 'top' | 'bottom' | 'left' | 'right';
    }>(),
    { position: 'right' },
);
</script>
